import { STD_ITEM_TXT_DEF_BEN_INIT_LOADING, STD_ITEM_TXT_DEF_BEN_INIT_SUCCESS, STD_ITEM_TXT_DEF_BEN_INIT_FAIL, STD_ITEM_TXT_DEF_BEN_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import clone from 'clone'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  stdItemTxtDefBen: {
    stdItemTxtDefBenId: {
      stdRiskTxtRef: null,
      stdItemTxtRef: null,
      benefit: null
    }
  }
}

const getters = {

}

const mutations = {
  [STD_ITEM_TXT_DEF_BEN_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [STD_ITEM_TXT_DEF_BEN_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [STD_ITEM_TXT_DEF_BEN_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [STD_ITEM_TXT_DEF_BEN_COMMIT_KEY](state, data) {
    state.stdItemTxtDefBen.stdItemTxtDefBenId.stdRiskTxtRef = data.stdRiskTxtRef
    state.stdItemTxtDefBen.stdItemTxtDefBenId.stdItemTxtRef = data.stdItemTxtRef
    state.stdItemTxtDefBen.stdItemTxtDefBenId.benefit = data.benefit
    state.stdItemTxtDefBen.stdItemTxtDefBenId.tranMode = data.tranMode
  }
}

const actions = {
  async stdItemTxtDefBenManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.stdItemTxtDefBenManagement
    commit(STD_ITEM_TXT_DEF_BEN_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(STD_ITEM_TXT_DEF_BEN_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(STD_ITEM_TXT_DEF_BEN_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
